/**
 * Kleine Helfer der Projektseite (Datum, Zahl, Uhrzeit).
 * Aus pages/ProjektDetailPage.tsx herausgelöst (Plan Projekt-Tracking, Etappe 2) —
 * verschoben, nicht umgeschrieben.
 */

export const MONATE = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

export function monatsLabel(ym: string): string {
  const [j, m] = ym.split("-");
  const idx = Number(m) - 1;
  return idx >= 0 && idx < 12 ? `${MONATE[idx]} ${j}` : ym;
}

export function h1Zahl(n: number): string {
  return (n || 0).toLocaleString("de-DE", { maximumFractionDigits: 1 });
}

export function heute(): string {
  return new Date().toISOString().slice(0, 10);
}

export function zahl(v: string): number | null {
  const t = (v || "").trim().replace(",", ".");
  if (!t) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

/** "2026-07-27T08:00:00+02:00" → "08:00" für die Zeitfelder der Stundenzeile. */
export function uhrzeit(iso: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}

/** Uhrzeit zurück in einen ISO-Zeitstempel am selben Tag wie die Vorlage. */
export function mitUhrzeit(iso: string | null, hhmm: string): string | null {
  if (!iso || !/^\d{1,2}:\d{2}$/.test(hhmm)) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const [h, m] = hhmm.split(":").map(Number);
  d.setHours(h, m, 0, 0);
  return d.toISOString();
}
